<mat-form-field class="role-search-input-field" appearance="outline">
  <mat-icon matPrefix>search</mat-icon>
  <input
    matInput
    [matAutocomplete]="auto"
    [disabled]="disabled"
    [attr.aria-label]="'translations.global.ariaLabels.addNewMember' | transloco"
    [placeholder]="placeholder"
    (focus)="onFocus()"
    (paste)="onTextPaste($event)"
    (keyup)="onSearchInputChange($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    class="role-search-result-autocomplete"
    [displayWith]="disabledAutocomplete"
    [thresholdPercent]="0.9"
    (optionsScroll)="onAutocompleteScroll()"
    (optionSelected)="onRoleSelected($event)"
  >
    <mat-option *ngFor="let role of roles" [value]="role" class="search-result-role-option">
      <span class="small">{{ getNameOfRole(role.name) }}</span>
    </mat-option>

    <div class="loading-more-indicator" *ngIf="isLoadingMore">
      <mat-spinner class="loading-more-indicator__spinner" [diameter]="30"></mat-spinner>
    </div>
  </mat-autocomplete>
  <mat-icon aria-hidden="true" matSuffix class="flex">
    <mat-spinner *ngIf="loadingRoles" [diameter]="18"> </mat-spinner>
  </mat-icon>
</mat-form-field>
